import { gql } from '@apollo/client';

export const GET_USER_TICKETS = gql`
  query GetUserTickets($userId: Int4 = "") {
    tickets(where: { raisedBy: { _eq: $userId } }, order_by: { createdAt: Desc }) {
      id
      title
      description
      type
      status
      priority
      assignedTo
      createdAt
      updatedAt
    }
  }
`;

export const GET_TICKET_BY_ID = gql`
  query GetTicketById($ticketId: Uuid = "") {
    ticketsById(id: $ticketId) {
      id
      title
      description
      status
      priority
      type
      assignedTo
      raisedBy
      createdAt
      updatedAt
      ticketUpdates(order_by: { createdAt: Asc }) {
        id
        comment
        createdAt
        updatedBy
        ticketId
      }
    }
  }
`;

export const INSERT_TICKET = gql`
  mutation InsertLearnerTicket(
    $description: Text = ""
    $priority: Text = ""
    $raisedBy: Int4 = ""
    $title: Text = ""
    $type: Text = ""
    $organisationId: Uuid = ""
    $ticketCategory: Text = "learner_support"
  ) {
    v2InsertTickets(
      objects: {
        description: $description
        priority: $priority
        raisedBy: $raisedBy
        title: $title
        type: $type
        organisationId: $organisationId
        ticketCategory: $ticketCategory
      }
    ) {
      affectedRows
    }
  }
`;

export const INSERT_TICKET_COMMENT = gql`
  mutation InsertLearnerTicketComment(
    $ticketId: Uuid = ""
    $updatedBy: Int4 = ""
    $comment: Text = ""
  ) {
    v2InsertTicketUpdates(
      objects: { comment: $comment, ticketId: $ticketId, updatedBy: $updatedBy }
    ) {
      affectedRows
    }
  }
`;

export const DELETE_TICKET = gql`
  mutation DeleteLearnerTicket($keyId: Uuid = "") {
    v2DeleteTicketsById(keyId: $keyId) {
      affectedRows
    }
  }
`;
